import axios from 'axios';
import { useState, useEffect } from 'react';
import { getColumnLength } from '../../helpers/utils';
import useConfirm from '../../../../components/common/useConfirm';

const workerType = {
  staff: 'staff',
  contractual: 'contractual',
  operator: 'operator',
};

const useGetData = (
  annual_date: string | null | undefined,
  created_date: string | null | undefined,
  department_id: string | null | undefined
) => {
  const [moduleData, setModuleData] = useState<any>({});
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSync, setIsSync] = useState(false);
  const [DialogSync, confirmSync] = useConfirm(
    'Sync New Parts',
    'Are you sure you want to Sync ? Make sure to save any changes before syncing!'
  );

  const handelSync = async () => {
    const ans = await confirmSync();
    if (!ans) return;
    axios
      .get(
        `/api/salaryRoute/syncPart/${moduleData._id}/${
          workerType.staff
        }/${department_id}/${getColumnLength(annual_date || '')}`
      )
      .then((res) => {
        window.alert(
          'successfully sync dont forget to save the document after sync'
        );
        const data = res.data.result;
        setModuleData(data);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    setIsLoading(true);
    const handleApi = async () => {
      try {
        const response = await axios.get(
          `/api/salaryRoute/${created_date}/${department_id}`
        );
        response.data.success && setModuleData(response.data.result);
        if (!response.data?.result?._id) {
          axios
            .get(
              `/api/salaryRoute/getAllEmp/${workerType.staff}/${department_id}`
            )
            .then((res) => {
              const response = res.data;
              const noOfDays = getColumnLength(annual_date || '');
              setModuleData((_: any) => ({
                total_w_day: noOfDays * response?.length,
                month_year: annual_date,
                created_date: created_date,
                list: response?.map((item: any, index: number) => ({
                  emp_id: item,
                })),
              }));
            })
            .catch((err) => {
              setIsLoading(false);
              setError(err);
            });
        }
      } catch (err: any) {
        setIsLoading(false);
        setError(err);
      }
    };

    handleApi();
  }, [isSync]);

  return {
    moduleData,
    setIsSync,
    isLoading,
    handelSync,
    DialogSync,
    error,
  };
};

export default useGetData;
